import { FC, useState } from 'react';

import TagItem from './TagItem';
import { Body2, Button } from '@fluentui/react-components';
import { ChevronDownRegular, ChevronUpRegular } from '@fluentui/react-icons';
import { THandleOpenAssociationDialog, TTag } from '../types';
import { TJurisdictionMap } from '@modules/items';

type TProps = {
  categoryName: string;
  tags: TTag[];
  jurisdictionsMap: TJurisdictionMap;
  selectedFolderIds: string[];
  handleOpenAssociationDialog: THandleOpenAssociationDialog;
};

const TagCategoryPanel: FC<TProps> = ({
  categoryName,
  tags,
  jurisdictionsMap,
  selectedFolderIds,
  handleOpenAssociationDialog,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(true);

  const toggleOpen = () => setIsOpen(!isOpen);

  return (
    <div className="flex flex-col items-start justify-between gap-4 w-full">
      <div className="flex justify-start items-center gap-1 w-full cursor-pointer" onClick={toggleOpen}>
        <Button
          appearance="transparent"
          icon={isOpen ? <ChevronUpRegular /> : <ChevronDownRegular />}
          iconPosition="before"
        />
        <Body2>{categoryName}</Body2>
      </div>

      {isOpen && (
        <div className="flex flex-col gap-6">
          {tags.map((tag) => (
            <TagItem
              key={tag._id}
              tag={tag}
              jurisdictionsMap={jurisdictionsMap}
              selectedFolderIds={selectedFolderIds}
              handleOpenAssociationDialog={handleOpenAssociationDialog}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default TagCategoryPanel;
